import React from 'react'
import styled from 'styled-components'
import {no_data_img }  from '@/styles/theme'
const EmptyImgContainer = styled.div`
 display: flex;
  flex-direction: column;
  align-items: center;
  margin: 10px 0;
  .img{
    margin: 10px 0;
    width: 170px;
    height: 110px;
    background: url(${props=> props.imageSrc? props.imageSrc: no_data_img}) no-repeat center;
    background-size: 100% ;
  }
  .txt{
    color: #9696a6;
    font-size: 12px;
  }
`

export default ({ text = "暂无数据",showImg= true, imageSrc }) => {
  return (
    <EmptyImgContainer imageSrc={imageSrc}>
      {showImg && <div className={'img'} ></div>}
      <div className={'txt'}>{text}</div>
    </EmptyImgContainer>
  )
}